import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { environment } from '../../../../../../apps/onmat-zero/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BigqueryProxyService {
  private apiUrl = `${environment.bigqueryUrl}`;

  constructor(private http: HttpClient) {}

  getIntercomToken(role: string, language: string): Observable<any> {
    const params = new HttpParams().set('role', role).set('language', language);
    return this.http.get(`${this.apiUrl}user_intercom_token`, { params });
  }
}
